const pauseYoutubeVideo = () => {
  const tabsWidgetContainer = [...document.getElementsByClassName("tabs-widget-container")];

  tabsWidgetContainer.forEach((element) => {
    const tabButtons = element.querySelectorAll(".js-tabs-button");

    const iframes = element.querySelectorAll<HTMLIFrameElement>(".youtube-video-iframe");

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        iframes.forEach((iframe) => {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "https://www.youtube.com"
          );
        });
      });
    });
  });
};

export default pauseYoutubeVideo;
